export default __webpack_public_path__ + "static/media/greenActiveSvg.1c57f84e.svg";